import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import AdUnit from '@/components/AdUnit.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineAdUnit',
  props: {
    index: null,
    everyXBuckets: { default: 4 },
    firstAdAt: { default: 0 },
    capsAt: { default: 3 }
  },
  setup(__props: any) {

const props = __props as { index: number, everyXBuckets: number, firstAdAt: number, capsAt: number };



const actualAdIndex = computed(() => {
	if (props.index < props.firstAdAt) return false;

	const i = (props.index - props.firstAdAt) / props.everyXBuckets;
	const isNotFloat = i % 1 === 0;
	const isNotCapped = i < props.capsAt;
	return isNotFloat && isNotCapped ? i + 1 : false;
});

return { __sfc: true,props, actualAdIndex, AdUnit }
}

})